import { MenuItem, ListItemIcon } from '@mui/material'
import { useUser } from 'app/User'
import React, { useState } from 'react'
import { useAuthActions } from 'store/auth/auth.store'
import { useAuth0 } from 'app/Auth'
import { useSurgeryActions } from 'store/notifications'

export const useLogic = () => {
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorElMenu)
  const { user, isRep } = useUser()
  const { handleLogout: handleLogoutAction } = useAuthActions()
  const { logout } = useAuth0()
  const { openSurgeryReminderModal } = useSurgeryActions()

  const handleLogout = async () => {
    if (isRep) {
      handleLogoutAction(() => {
        logout({ returnTo: `${window.location.origin}/?status=loggedout` })
      })
      handleClose()
      return
    }

    const confirmed = await openSurgeryReminderModal('logout')
    if (!confirmed) return

    handleLogoutAction(() => {
      logout({ returnTo: `${window.location.origin}/?status=loggedout` })
    })
    handleClose()
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorElMenu(null)
  }

  const renderMenuItem = (
    icon: React.ReactElement,
    text: string | undefined,
    onClick?: () => void
  ) => {
    return (
      <MenuItem onClick={onClick} sx={{ gap: user?.roles ? 2 : 0.5 }}>
        <ListItemIcon>{icon}</ListItemIcon>
        {text}
      </MenuItem>
    )
  }

  return {
    handleClick,
    handleClose,
    open,
    anchorElMenu,
    handleLogout,
    name: user?.nickname,
    picture: user?.picture,
    email: user?.email,
    roles: user?.roles,
    renderMenuItem,
  }
}
